export default __webpack_public_path__ + "static/media/darkSharpTurn.a9994015.png";